import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM13 14C11.3431 14 10 15.3431 10 17V18H18V17C18 15.3431 16.6569 14 15 14H13ZM9 12C8.39493 12 7.54085 12.1609 6.81152 12.7051C6.03329 13.2858 5.50005 14.2297 5.5 15.5547V17H7.5V15.5547C7.50004 14.8261 7.76295 14.4914 8.00781 14.3086C8.30178 14.0893 8.69843 14 9 14H10V12H9ZM14 8C12.6193 8 11.5 9.11929 11.5 10.5C11.5 11.8807 12.6193 13 14 13C15.3807 13 16.5 11.8807 16.5 10.5C16.5 9.11929 15.3807 8 14 8ZM10 6C8.61929 6 7.5 7.11929 7.5 8.5C7.5 9.88071 8.61929 11 10 11C10.0104 11 10.0208 10.9982 10.0312 10.998C10.011 10.8349 10 10.6687 10 10.5C10 9.01308 10.8115 7.71586 12.0156 7.02637C11.5608 6.40528 10.8288 6 10 6Z"}}]};

const UsergroupCircleFilled = Vue.extend<IconProps>({
  name: 'UsergroupCircleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'usergroup-circle-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UsergroupCircleFilled;
